




import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
	components: {
	}
})
export default class ChartRenderNew extends Vue {
	@Prop() resultSet: any;
}
